import { mediaRef } from '@/services/mediaAssets';
import { anniversaryDinner, chickFilAFriday } from '@/content/culture/traditions';
import { reckonBallEvents } from '@/content/reckon-ball';
import { buildPassportStatCollections } from '@/lib/passports/stats.cjs';
import { achievementDefinitions } from '@/data/reckonWayTags';
import { reckonWayEventBySlug } from '@/data/reckon-way/events';
import { eventEntityRoute } from '@/lib/reckon-way/entityDetails';

const alHeadshot = mediaRef('lames/Al M.jpeg');
const benHeadshot = mediaRef('lames/Ben B.jpeg');
const bradHeadshot = mediaRef('lames/Brad B.jpeg');
const brandonAHeadshot = mediaRef('lames/Brandon A New.jpeg');
const brandonLHeadshot = mediaRef('lames/Brandon L New.jpeg');
const jasmineHeadshot = mediaRef('lames/Jasmine B.jpeg');
const kevinHeadshot = mediaRef('lames/Kevin L.jpeg');
const marcusHeadshot = mediaRef('lames/Marcus G New.jpeg');
const mattHeadshot = mediaRef('lames/Matt G.jpeg');
const phillipHeadshot = mediaRef('lames/Phillip H.jpeg');

export const adventureLevels = [
  { level: 'Explorer', minBadges: 1, maxBadges: 5 },
  { level: 'Trailblazer', minBadges: 6, maxBadges: 15 },
  { level: 'Navigator', minBadges: 16, maxBadges: 30 },
  { level: 'Pathfinder', minBadges: 31, maxBadges: 50 },
  { level: 'Legend', minBadges: 51, maxBadges: null },
];

const crewBase = [
  {
    slug: 'kevin-l',
    fullName: 'Kevin L.',
    displayName: 'Kevin L.',
    preferredName: 'Kevin',
    title: 'Chief Executive Officer',
    headshot: kevinHeadshot,
    passportNumber: 'RC-0001',
    crewMemberSince: '2022',
    location: 'Northern Virginia',
    linkedInUrl: 'https://www.linkedin.com/in/kevinl77/',
    shortQuote: "We don't just build software. We build the stories people will tell for the rest of their lives.",
    status: 'active',
  },
  {
    slug: 'brandon-a',
    fullName: 'Brandon A.',
    displayName: 'Brandon A.',
    preferredName: 'Brandon',
    title: 'Co-Founder',
    headshot: brandonAHeadshot,
    passportNumber: 'RC-0002',
    crewMemberSince: '2022',
    location: 'Northern Virginia',
    linkedInUrl: 'https://www.linkedin.com/in/brandon-armstrong/',
    shortQuote: 'Build it, test it, then go see the world.',
    status: 'active',
  },
  {
    slug: 'marcus-g',
    fullName: 'Marcus G.',
    displayName: 'Marcus G.',
    preferredName: 'Marcus',
    title: 'Co-Founder',
    headshot: marcusHeadshot,
    passportNumber: 'RC-0003',
    crewMemberSince: '2022',
    location: 'Northern Virginia',
    linkedInUrl: 'https://www.linkedin.com/in/marcus-gunn-568a271b2/',
    shortQuote: 'Curiosity makes the best compass.',
    status: 'active',
  },
  {
    slug: 'brandon-l',
    fullName: 'Brandon L.',
    displayName: 'Brandon L.',
    preferredName: 'Brandon',
    title: 'Co-Founder',
    headshot: brandonLHeadshot,
    passportNumber: 'RC-0004',
    crewMemberSince: '2022',
    location: 'Northern Virginia',
    linkedInUrl: 'https://www.linkedin.com/in/brandon-s-lea/',
    shortQuote: 'The best systems are built by teams that trust each other.',
    status: 'active',
  },
  {
    slug: 'al-m',
    fullName: 'Al M.',
    displayName: 'Al M.',
    preferredName: 'Al',
    title: 'Software Developer',
    headshot: alHeadshot,
    passportNumber: 'RC-0005',
    crewMemberSince: '2023',
    location: 'Northern Virginia',
    shortQuote: 'Every story starts with saying yes.',
    status: 'active',
  },
  {
    slug: 'matt-g',
    fullName: 'Matt G.',
    displayName: 'Matt G.',
    preferredName: 'Matt',
    title: 'Software Developer',
    headshot: mattHeadshot,
    passportNumber: 'RC-0006',
    crewMemberSince: '2023',
    location: 'Northern Virginia',
    linkedInUrl: 'https://www.linkedin.com/in/matthewggraves/',
    shortQuote: 'There is always another trail to explore.',
    status: 'active',
  },
  {
    slug: 'jasmine-b',
    fullName: 'Jasmine B.',
    displayName: 'Jasmine B.',
    preferredName: 'Jasmine',
    title: 'Software Developer',
    headshot: jasmineHeadshot,
    passportNumber: 'RC-0007',
    crewMemberSince: '2023',
    location: 'Northern Virginia',
    linkedInUrl: 'https://www.linkedin.com/in/jasmine-barnes-03b311154/',
    shortQuote: 'Find the view worth remembering.',
    status: 'active',
  },
  {
    slug: 'ben-b',
    fullName: 'Ben B.',
    displayName: 'Ben B.',
    preferredName: 'Ben',
    title: 'Software Developer',
    headshot: benHeadshot,
    passportNumber: 'RC-0008',
    crewMemberSince: '2023',
    location: 'Northern Virginia',
    linkedInUrl: 'https://www.linkedin.com/in/benbrandt/',
    shortQuote: 'Measure twice, wander often.',
    status: 'active',
  },
  {
    slug: 'phillip-h',
    fullName: 'Phillip H.',
    displayName: 'Phillip H.',
    preferredName: 'Phillip',
    title: 'Software Developer',
    headshot: phillipHeadshot,
    passportNumber: 'RC-0009',
    crewMemberSince: '2024',
    location: 'Northern Virginia',
    linkedInUrl: 'https://www.linkedin.com/in/phillip-hetzler/',
    shortQuote: 'Leave room for the unexpected.',
    status: 'active',
  },
  {
    slug: 'brad-b',
    fullName: 'Brad B.',
    displayName: 'Brad B.',
    preferredName: 'Brad',
    title: 'Alumni Crew Member',
    headshot: bradHeadshot,
    passportNumber: 'RC-0010',
    crewMemberSince: '2024',
    crewMemberThrough: '2026',
    location: 'Northern Virginia',
    shortQuote: 'Adventure is better when everyone is invited.',
    status: 'alumni',
  },
];

const allCurrentCrew = [
  'kevin-l',
  'brandon-a',
  'marcus-g',
  'brandon-l',
  'al-m',
  'matt-g',
  'jasmine-b',
  'ben-b',
  'phillip-h',
];

const familyRetreatCrew = [
  ...allCurrentCrew,
  'brad-b',
];

const createTeamDinnerRecords = (tripSlug, dinners) => dinners.map((dinner, index) => ({
  id: `${tripSlug}-team-dinner-${index + 1}`,
  ...(typeof dinner === 'string' ? { name: dinner } : dinner),
}));

const tripSourceRoutes = {
  'aws-reinvent-2022': { name: 'aws-reinvent', hash: '#year-2022' },
  'aws-reinvent-2023': { name: 'aws-reinvent', hash: '#year-2023' },
  'aws-reinvent-2024': { name: 'aws-reinvent', hash: '#year-2024' },
  'aws-reinvent-2025': { name: 'aws-reinvent', hash: '#year-2025' },
  'bahamas-atlantis-2024': {
    name: 'reckon-way-gallery', params: { gallerySlug: 'bahamas-2024' },
  },
  'xcaret-corporate-retreat-2025': {
    name: 'reckon-way-gallery', params: { gallerySlug: 'xcaret-2025' },
  },
  'sxsw-london-2025': {
    name: 'reckon-way-gallery', params: { gallerySlug: 'sxsw-london-2025' },
  },
  'sxsw-sydney-2025': {
    name: 'reckon-way-gallery', params: { gallerySlug: 'sxsw-sydney-2025' },
  },
  'iceland-corporate-retreat-2026': {
    name: 'reckon-way-gallery', params: { gallerySlug: 'iceland-corporate-retreat-2026' },
  },
};

const crewSlugsEligibleInYear = (year) => crewBase
  .filter((crewMember) => Number(crewMember.crewMemberSince) <= year)
  .map((crewMember) => crewMember.slug);

const reckonBallDinnerRecords = reckonBallEvents.map((event) => ({
  id: `reckon-ball-${event.year}-team-dinner`,
  name: event.dining.restaurant,
  eventName: event.title,
  eyebrow: 'Reckon Ball Dinner',
  date: `Reckon Ball ${event.year}`,
  location: event.dining.location,
  description: event.dining.summary,
  media: [
    ...(event.dining.images || []),
    ...(event.gallery || []).filter((image) => (
      [image.alt, image.caption].filter(Boolean).join(' ').toLowerCase()
        .includes(event.dining.restaurant.toLowerCase())
    )),
  ].map((image, index) => ({
    id: image.id || `reckon-ball-${event.year}-dinner-${index + 1}`,
    src: image.src,
    alt: image.alt || `${event.dining.restaurant} at Reckon Ball ${event.year}`,
    caption: image.caption,
  })),
  sourceRoute: { name: 'reckon-ball-year', params: { year: String(event.year) } },
  attendees: crewSlugsEligibleInYear(event.year),
}));

const today = new Date();
const completedAnniversaryDinnerRecords = anniversaryDinner.occurrences
  .filter((occurrence) => new Date(`${occurrence.date}T23:59:59`) <= today)
  .map((occurrence) => {
    const year = Number(occurrence.date.slice(0, 4));
    return {
      id: `${occurrence.id}-team-dinner`,
      name: occurrence.place.name,
      eventName: occurrence.title,
      eyebrow: 'Anniversary Dinner',
      date: occurrence.title,
      location: [occurrence.place.city, occurrence.place.state].filter(Boolean).join(', '),
      description: occurrence.summary,
      media: occurrence.gallery || [],
      sourceRoute: {
        name: 'reckon-way-tradition', params: { traditionSlug: anniversaryDinner.slug },
      },
      attendees: crewSlugsEligibleInYear(year),
    };
  });

const traditionDinnerRecords = [
  ...reckonBallDinnerRecords,
  ...completedAnniversaryDinnerRecords,
];

const tripRecords = [
  {
    slug: 'aws-reinvent-2022',
    tripName: 'AWS re:Invent 2022',
    destination: 'Las Vegas',
    country: 'United States',
    date: 'November 2022',
    tripType: 'Conference',
    teamDinners: createTeamDinnerRecords('aws-reinvent-2022', [
      'STK',
      'Amalfi by Bobby Flay',
      'Bazaar Meat',
    ]),
    attendees: ['kevin-l', 'brandon-a', 'brandon-l', 'marcus-g'],
    badges: ['ATV Adventure'],
  },
  {
    slug: 'aws-reinvent-2023',
    tripName: 'AWS re:Invent 2023',
    destination: 'Las Vegas',
    country: 'United States',
    date: 'November 2023',
    tripType: 'Conference',
    teamDinners: createTeamDinnerRecords('aws-reinvent-2023', [
      'STK',
      'Catch',
      'Bazaar Meat',
    ]),
    attendees: ['kevin-l', 'brandon-a', 'brandon-l', 'marcus-g', 'al-m', 'matt-g'],
    badges: ['UTV Adventure', 'U2 at Sphere'],
  },
  {
    slug: 'bahamas-atlantis-2024',
    tripName: 'Atlantis Paradise Island',
    destination: 'Paradise Island',
    country: 'Bahamas',
    date: 'May 2024',
    tripType: 'Corporate Retreat',
    teamDinners: createTeamDinnerRecords('bahamas-atlantis-2024', [
      { name: 'Bahamas Dinner Location to Confirm', needsLocation: true },
      { name: 'Bahamas Dinner Location to Confirm', needsLocation: true },
    ]),
    attendees: familyRetreatCrew,
    badges: ['Exploring Atlantis'],
  },
  {
    slug: 'aws-reinvent-2024',
    tripName: 'AWS re:Invent 2024',
    destination: 'Las Vegas',
    country: 'United States',
    date: 'December 2024',
    tripType: 'Conference',
    teamDinners: createTeamDinnerRecords('aws-reinvent-2024', [
      'STK',
      'Catch',
      'Brezza',
      'Golden Steer',
      'Don’s Prime',
      'Estiatorio Milos',
    ]),
    attendees: ['kevin-l', 'brandon-a', 'brandon-l', 'marcus-g', 'al-m', 'jasmine-b', 'ben-b', 'matt-g'],
    badges: ['Valley of Fire', 'Hiking Zion National Park', 'Eagles at Sphere'],
  },
  {
    slug: 'xcaret-corporate-retreat-2025',
    tripName: 'Xcaret Corporate Retreat',
    destination: 'Riviera Maya',
    country: 'Mexico',
    date: 'April 2025',
    tripType: 'Corporate Retreat',
    teamDinners: createTeamDinnerRecords('xcaret-corporate-retreat-2025', [
      { name: 'Xcaret Dinner Location to Confirm', needsLocation: true },
      { name: 'Xcaret Dinner Location to Confirm', needsLocation: true },
      { name: 'Xcaret Dinner Location to Confirm', needsLocation: true },
    ]),
    attendees: familyRetreatCrew,
    badges: ['Catamaran Sailing', 'Coba & Cenotes'],
  },
  {
    slug: 'sxsw-london-2025',
    tripName: 'SXSW London 2025',
    destination: 'London',
    destinations: ['London', 'Dublin'],
    country: 'United Kingdom',
    countries: ['United Kingdom', 'Ireland'],
    date: 'June 2025',
    tripType: 'Conference',
    teamDinners: createTeamDinnerRecords('sxsw-london-2025', ['Poulet']),
    attendees: ['kevin-l', 'marcus-g'],
    badges: ['Bermondsey Beer Mile', 'Guinness Storehouse and Temple Bar'],
  },
  {
    slug: 'sxsw-sydney-2025',
    tripName: 'SXSW Sydney 2025',
    destination: 'Sydney',
    country: 'Australia',
    date: 'October 2025',
    tripType: 'Conference',
    teamDinners: createTeamDinnerRecords('sxsw-sydney-2025', [
      'Quay',
      'Nine Dragons',
      '20 Chapel',
      'Margaret',
    ]),
    attendees: ['kevin-l', 'brandon-a', 'brandon-l', 'matt-g', 'ben-b', 'phillip-h'],
    badges: ['Ferry to Manly Beach', 'Coogee to Bondi Coastal Walk', 'Scenic World Blue Mountains'],
  },
  {
    slug: 'aws-reinvent-2025',
    tripName: 'AWS re:Invent 2025',
    destination: 'Las Vegas',
    country: 'United States',
    date: 'December 2025',
    tripType: 'Conference',
    teamDinners: createTeamDinnerRecords('aws-reinvent-2025', ['Jean-Georges Steakhouse']),
    attendees: ['kevin-l', 'marcus-g'],
    badges: [],
  },
  {
    slug: 'iceland-corporate-retreat-2026',
    tripName: 'Iceland Corporate Retreat',
    destination: 'Iceland',
    country: 'Iceland',
    date: 'March 2026',
    tripType: 'Corporate Retreat',
    teamDinners: createTeamDinnerRecords('iceland-corporate-retreat-2026', [
      'Lava Restaurant',
      'Torfhús Retreat',
      'Ylja',
      'Fish Company',
      'Grillmarkaðurinn',
    ]),
    attendees: familyRetreatCrew,
    badges: ['Snowmobiling Langjokull', 'South Coast to Reykjavik'],
  },
];

const favoriteBySlug = {
  'kevin-l': {
    favoriteExperience: 'SXSW London conference',
    favoriteMeal: 'Poulet',
    favoriteActivity: 'Snowmobiling in Iceland',
    favoriteCity: 'Sydney',
  },
  'brandon-a': {
    favoriteExperience: 'SXSW Sydney',
    favoriteMeal: 'Quay',
    favoriteActivity: 'Coogee to Bondi Coastal Walk',
    favoriteCity: 'Sydney',
  },
  'marcus-g': {
    favoriteExperience: 'SXSW London',
    favoriteMeal: 'Poulet',
    favoriteActivity: 'Bermondsey Beer Mile',
    favoriteCity: 'London',
  },
  'brandon-l': {
    favoriteExperience: 'SXSW Sydney',
    favoriteMeal: 'Margaret',
    favoriteActivity: 'Scenic World Blue Mountains',
    favoriteCity: 'Sydney',
  },
  'al-m': {
    favoriteExperience: 'Xcaret Corporate Retreat',
    favoriteMeal: 'Team dinners in Mexico',
    favoriteActivity: 'Valley of Fire',
    favoriteCity: 'Las Vegas',
  },
  'matt-g': {
    favoriteExperience: 'SXSW Sydney',
    favoriteMeal: '20 Chapel',
    favoriteActivity: 'Coogee to Bondi Coastal Walk',
    favoriteCity: 'Sydney',
  },
  'jasmine-b': {
    favoriteExperience: 'Xcaret Corporate Retreat',
    favoriteMeal: 'Team dinners in Mexico',
    favoriteActivity: 'Hiking Zion National Park',
    favoriteCity: 'Las Vegas',
  },
  'ben-b': {
    favoriteExperience: 'SXSW Sydney',
    favoriteMeal: 'Nine Dragons',
    favoriteActivity: 'Ferry to Manly Beach',
    favoriteCity: 'Sydney',
  },
  'phillip-h': {
    favoriteExperience: 'SXSW Sydney',
    favoriteMeal: 'Quay',
    favoriteActivity: 'Scenic World Blue Mountains',
    favoriteCity: 'Sydney',
  },
  'brad-b': {
    favoriteExperience: 'Family-inclusive retreats',
    favoriteMeal: 'Team dinners',
    favoriteActivity: 'Exploring Atlantis',
    favoriteCity: 'Riviera Maya',
  },
};

const favoriteTripSlugsByCrew = {
  'kevin-l': {
    favoriteExperience: 'sxsw-london-2025',
    favoriteMeal: 'sxsw-london-2025',
    favoriteActivity: 'iceland-corporate-retreat-2026',
    favoriteCity: 'sxsw-sydney-2025',
  },
  'brandon-a': {
    favoriteExperience: 'sxsw-sydney-2025',
    favoriteMeal: 'sxsw-sydney-2025',
    favoriteActivity: 'sxsw-sydney-2025',
    favoriteCity: 'sxsw-sydney-2025',
  },
  'marcus-g': {
    favoriteExperience: 'sxsw-london-2025',
    favoriteMeal: 'sxsw-london-2025',
    favoriteActivity: 'sxsw-london-2025',
    favoriteCity: 'sxsw-london-2025',
  },
  'brandon-l': {
    favoriteExperience: 'sxsw-sydney-2025',
    favoriteMeal: 'sxsw-sydney-2025',
    favoriteActivity: 'sxsw-sydney-2025',
    favoriteCity: 'sxsw-sydney-2025',
  },
  'al-m': {
    favoriteExperience: 'xcaret-corporate-retreat-2025',
    favoriteMeal: 'xcaret-corporate-retreat-2025',
    favoriteActivity: 'aws-reinvent-2024',
    favoriteCity: 'aws-reinvent-2024',
  },
  'matt-g': {
    favoriteExperience: 'sxsw-sydney-2025',
    favoriteMeal: 'sxsw-sydney-2025',
    favoriteActivity: 'sxsw-sydney-2025',
    favoriteCity: 'sxsw-sydney-2025',
  },
  'jasmine-b': {
    favoriteExperience: 'xcaret-corporate-retreat-2025',
    favoriteMeal: 'xcaret-corporate-retreat-2025',
    favoriteActivity: 'aws-reinvent-2024',
    favoriteCity: 'aws-reinvent-2024',
  },
  'ben-b': {
    favoriteExperience: 'sxsw-sydney-2025',
    favoriteMeal: 'sxsw-sydney-2025',
    favoriteActivity: 'sxsw-sydney-2025',
    favoriteCity: 'sxsw-sydney-2025',
  },
  'phillip-h': {
    favoriteExperience: 'sxsw-sydney-2025',
    favoriteMeal: 'sxsw-sydney-2025',
    favoriteActivity: 'sxsw-sydney-2025',
    favoriteCity: 'sxsw-sydney-2025',
  },
  'brad-b': {
    favoriteExperience: 'xcaret-corporate-retreat-2025',
    favoriteMeal: 'xcaret-corporate-retreat-2025',
    favoriteActivity: 'bahamas-atlantis-2024',
    favoriteCity: 'xcaret-corporate-retreat-2025',
  },
};

const getAdventureLevelForBadges = (badgeCount) => adventureLevels.find((level) => (
  badgeCount >= level.minBadges
  && (level.maxBadges === null || badgeCount <= level.maxBadges)
)) || adventureLevels[0];

const achievementSlugByPassportBadgeName = {
  'ATV Adventure': 'atvs-mojave-desert',
  'UTV Adventure': 'utvs-mojave-desert',
  'U2 at Sphere': 'u2-at-sphere',
  'Exploring Atlantis': 'exploring-atlantis',
  'Valley of Fire': 'valley-of-fire-off-roading',
  'Hiking Zion National Park': 'hiking-zion-national-park',
  'Eagles at Sphere': 'eagles-at-sphere',
  'Catamaran Sailing': 'catamaran-sailing',
  'Coba & Cenotes': 'coba-and-cenotes',
  'Bermondsey Beer Mile': 'bermondsey-beer-mile',
  'Guinness Storehouse and Temple Bar': 'historic-pub-crawl',
  'Ferry to Manly Beach': 'ferry-to-manly-beach',
  'Coogee to Bondi Coastal Walk': 'bondi-to-coogee-coastal-walk',
  'Scenic World Blue Mountains': 'scenic-world-blue-mountains',
  'Snowmobiling Langjokull': 'snowmobiling-langjokull',
  'South Coast to Reykjavik': 'south-coast-to-reykjavik',
};
const achievementBySlug = new Map(achievementDefinitions.map((achievement) => (
  [achievement.slug, achievement]
)));

const activityRouteForAchievement = (achievement) => {
  if (!achievement) return null;
  const event = reckonWayEventBySlug[achievement.tripSlug];
  if (!event) return null;
  const activity = (event.activities || []).find((item) => (
    item.meritBadgeSlug === achievement.slug
    || item.relatedBadgeIds?.includes(achievement.slug)
    || item.entityId === achievement.slug
    || item.id === achievement.slug
    || item.slug === achievement.slug
  ));
  return activity ? eventEntityRoute(event, 'activities', activity) : null;
};

const favoriteActivityBadgeNames = {
  'snowmobiling in iceland': 'Snowmobiling Langjokull',
};

const normalizePassportRecordName = (value = '') => value
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, ' ')
  .trim();

const chickFilATrophyDetails = {
  1: { place: '1st Place', title: 'Chick-fil-A Friday Champion', tone: 'gold' },
  2: { place: '2nd Place', title: 'Chick-fil-A Friday Runner-Up', tone: 'silver' },
  3: { place: '3rd Place', title: 'Chick-fil-A Friday Podium', tone: 'bronze' },
};

const chickFilATrophyByPassportSlug = new Map(chickFilAFriday.attendance
  .filter((record) => record.passportSlug && record.rank && record.rank <= 3)
  .map((record) => [record.passportSlug, {
    ...chickFilATrophyDetails[record.rank],
    rank: record.rank,
    attendedEvents: record.attendedEvents,
    eligibleEvents: record.eligibleEvents,
    attendancePercentage: record.attendancePercentage,
  }]));

const buildPassport = (crewMember) => {
  const trips = tripRecords
    .filter((trip) => trip.attendees.includes(crewMember.slug))
    .map((trip) => ({ ...trip, sourceRoute: tripSourceRoutes[trip.slug] }));
  const traditionDinners = traditionDinnerRecords
    .filter((dinner) => dinner.attendees.includes(crewMember.slug));
  const statDetails = buildPassportStatCollections(trips, traditionDinners);
  const badges = statDetails.badges.items.map((badge) => {
    const achievement = achievementBySlug.get(achievementSlugByPassportBadgeName[badge.name]);
    const activityRoute = activityRouteForAchievement(achievement);

    return {
      ...badge,
      achievementSlug: achievement?.slug || null,
      image: achievement?.image || null,
      activityRoute,
      sourceRoutes: activityRoute ? [{ label: badge.name, route: activityRoute }] : badge.sourceRoutes,
    };
  });
  statDetails.badges.items = badges;
  const adventureLevelDetails = getAdventureLevelForBadges(statDetails.badges.count);
  const favorites = favoriteBySlug[crewMember.slug] || {};
  const favoriteTripSlugs = favoriteTripSlugsByCrew[crewMember.slug] || {};
  const passportRecordRoute = (statKey, record) => (record ? {
    name: 'passport-record',
    params: {
      employeeSlug: crewMember.slug,
      statKey,
      recordId: record.id,
    },
  } : {
    name: 'passport-stat',
    params: { employeeSlug: crewMember.slug, statKey },
  });
  const recordForTrip = (statKey, favoriteKey) => statDetails[statKey].items
    .find((item) => item.tripSlug === favoriteTripSlugs[favoriteKey]
      || item.id === favoriteTripSlugs[favoriteKey]);
  const favoriteMealRecord = statDetails['team-dinners'].items.find((item) => (
    item.tripSlug === favoriteTripSlugs.favoriteMeal
    && normalizePassportRecordName(item.name) === normalizePassportRecordName(favorites.favoriteMeal)
  ));
  const favoriteActivityName = favoriteActivityBadgeNames[
    normalizePassportRecordName(favorites.favoriteActivity)
  ] || favorites.favoriteActivity;
  const favoriteActivityRecord = statDetails.badges.items.find((item) => (
    item.tripSlug === favoriteTripSlugs.favoriteActivity
    && normalizePassportRecordName(item.name) === normalizePassportRecordName(favoriteActivityName)
  ));
  const favoriteCityRecord = statDetails.destinations.items.find((item) => (
    normalizePassportRecordName(item.title) === normalizePassportRecordName(favorites.favoriteCity)
  ));

  return {
    ...crewMember,
    chickFilAFridayTrophy: chickFilATrophyByPassportSlug.get(crewMember.slug) || null,
    playerCardRoute: { name: 'reckon-way-people', hash: `#${crewMember.slug}` },
    adventureLevel: adventureLevelDetails.level,
    adventureLevelDetails,
    stats: {
      countriesVisited: statDetails.countries.count,
      destinationsExplored: statDetails.destinations.count,
      reckonTrips: statDetails.adventures.count,
      meritBadgesEarned: statDetails.badges.count,
      teamDinners: statDetails['team-dinners'].count,
      conferences: statDetails.conferences.count,
      retreats: statDetails.retreats.count,
      favoriteExperience: favorites.favoriteExperience || 'Reckon adventures',
      favoriteExperienceRoute: passportRecordRoute(
        'adventures',
        recordForTrip('adventures', 'favoriteExperience'),
      ),
    },
    statDetails,
    stamps: trips,
    badges,
    favorites: {
      favoriteMeal: favorites.favoriteMeal || 'Team dinner',
      favoriteMealRoute: passportRecordRoute('team-dinners', favoriteMealRecord),
      favoriteActivity: favorites.favoriteActivity || 'Shared adventures',
      favoriteActivityRoute: favoriteActivityRecord?.activityRoute
        || passportRecordRoute('badges', favoriteActivityRecord),
      favoriteCity: favorites.favoriteCity || 'Wherever the crew gathers',
      favoriteCityRoute: passportRecordRoute('destinations', favoriteCityRecord),
    },
  };
};

export const passportList = crewBase.map(buildPassport);
export const activePassportList = passportList.filter((passport) => passport.status === 'active');
export const passportBySlug = passportList.reduce((passportsBySlug, passport) => ({
  ...passportsBySlug,
  [passport.slug]: passport,
}), {});
